import classes from "./WelcomeMessage.module.css";
import apple from "./../../../assets/images/apple.png";
import android from "./../../../assets/images/android.png";
import information from "./../../../assets/images/information_project.png";
import { useTranslation } from "react-i18next";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
  welcomeMessageContent,
} from "../../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../../hooks/language-context";
import { useHistory } from "react-router-dom";
import SvgTermsofuse2 from "../../../assets/icons/Termsofuse2";

import sponsor1 from "../../../../SMARTCITY/assets/images/sponsor_1.png";
import sponsor2 from "../../../../SMARTCITY/assets/images/sponsor_2.png";

import styled from "styled-components";

const WelcomeMessage = () => {
  const { t } = useTranslation();
  const languageCtx = useContext(LanguageContext);
  const history = useHistory();
  return (
    <Container>
      <WelcomeText>
        <p>{t(welcomeMessageContent[0])}</p>
        <p>{t(welcomeMessageContent[1])}</p>
      </WelcomeText>
      <WelcomeItems>
        {/* <img style={{ width: "100%" }} src={sponsor1} />
        
        <img style={{ width: "100%" }} src={sponsor2} /> */}
        <Wrapper onClick={() => history.push("/terms-of-use")}>
          {" "}
          <SvgTermsofuse2 width={35} style={{ paddingLeft: "10px" }} />
          {languageCtx.languageCode === "el" ? (
            <p>{t("Όροι Χρήσης")}</p>
          ) : (
            <p>{t("Terms of Use")}</p>
          )}
        </Wrapper>
        <Wrapper onClick={() => history.push("/accessibility")}>
          {" "}
          <SvgTermsofuse2 width={35} style={{ paddingLeft: "10px" }} />
          {languageCtx.languageCode === "el" ? (
            <p>{t("Δήλωση προσβασιμότητας")}</p>
          ) : (
            <p>{t("Terms of Use")}</p>
          )}
        </Wrapper>
      </WelcomeItems>

      {/* <div
          style={{ marginBottom: 5 }}
          onClick={() => history.push("/accessibility")}
        >
          <SvgTermsofuse2 width={35} />
          {languageCtx.languageCode === "el" ? (
            <p>{t("Δήλωση προσβασιμότητας")}</p>
          ) : (
            <p>{t("Terms of Use")}</p>
          )}
        </div>
        <div
          onClick={() =>
            window.open(
              languageCtx.languageCode === "en"
                ? informationLinkEN
                : informationLink
            )
          }
        >
          <img src={information} alt={"information-application"} width={35} />
          <p>{t("Πληροφορίες για το έργο")}</p>
        </div>
        <div>
          <img
            src={apple}
            alt={"apple-application"}
            width={150}
            onClick={() => window.open(iosAppLink)}
          />
          <img
            src={android}
            alt={"android-application"}
            width={150}
            onClick={() => window.open(androidAppLink)}
          />
        </div> */}
      {/* </div> */}
    </Container>
  );
};

export default WelcomeMessage;

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  padding: 10px 20px;
  line-height: 1.5;
  font-weight: 700;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // background-color: red;

  @media only screen and (max-width: 942px) {
    // width: 400px;
    height: 100%;
  }
`;

const WelcomeText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const WelcomeItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  @media only screen and (max-width: 942px) {
    width: 280px;
    margin: 0 auto;
    // flex-direction: row;
    // flex-wrap: wrap;
  }
  // background-color: yellow;
`;

const Wrapper = styled.div`
  width: calc(100% - 2px);
  height: 50px;
  background-color: #000;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
`;
